export const translations = {
  fr: {
    brand: "Kelsy Housecleaning",
    location: "Ottawa · Gatineau",
    nav: { services: "Services", why: "Pourquoi nous", areas: "Zones", quote: "Devis", contact: "Contact", app: "Télécharger l'app", admin: "Espace admin" },
    hero: {
      badge: "Nettoyage résidentiel & commercial",
      line1: "Une maison",
      line2: "impeccable,",
      line3: "l'esprit léger.",
      sub: "Nettoyage professionnel de maisons, appartements, condos et bureaux à Ottawa & Gatineau. Fiable, minutieux, satisfaction garantie.",
      cta1: "Demander un devis",
      cta2: "Nos services",
      stat1: "Clients satisfaits",
      stat2: "Villes desservies",
      stat3: "Satisfaction garantie",
    },
    marquee: ["Maison propre", "Esprit léger", "Qualité garantie", "Ottawa & Gatineau", "Produits professionnels", "Personnel de confiance"],
    services: {
      overline: "Nos services",
      title: "Un nettoyage taillé sur mesure",
      sub: "De l'entretien régulier au grand ménage, nous adaptons chaque visite à vos besoins.",
      items: [
        { n: "01", t: "Nettoyage régulier", d: "Visites hebdomadaires, aux deux semaines ou mensuelles adaptées à votre rythme de vie." },
        { n: "02", t: "Grand ménage", d: "Un nettoyage en profondeur, du plafond au plancher, pour un résultat impeccable." },
        { n: "03", t: "Maisons & appartements", d: "Services fiables pour maisons, appartements et condos partout dans la région d'Ottawa." },
        { n: "04", t: "Bureaux & commercial", d: "Des espaces de travail sains et éclatants pour une meilleure productivité." },
        { n: "05", t: "Emménagement / déménagement", d: "On remet les lieux à neuf avant votre arrivée ou après votre départ." },
        { n: "06", t: "Sur demande", d: "Fenêtres, électroménagers, réfrigérateur — dites-nous ce dont vous avez besoin." },
      ],
    },
    why: {
      overline: "Pourquoi Kelsy",
      title: "La propreté est notre priorité",
      items: [
        { t: "Personnel fiable et de confiance", d: "Une équipe formée, courtoise et vérifiée qui respecte votre intimité." },
        { t: "Produits & équipements pro", d: "Des produits efficaces et un équipement de qualité professionnelle." },
        { t: "Satisfaction garantie", d: "Pas satisfait ? Nous revenons corriger, sans frais." },
        { t: "Service flexible", d: "Des horaires et des formules qui s'adaptent à votre vie." },
      ],
      tagline: "La propreté est notre priorité !",
    },
    areas: {
      overline: "Zones desservies",
      title: "Fièrement au service d'Ottawa & Gatineau",
      sub: "Nous couvrons l'ensemble de la région de la capitale nationale et ses environs.",
      list: ["Ottawa", "Gatineau", "Orléans", "Kanata", "Barrhaven", "Nepean", "Hull", "Aylmer", "Gloucester"],
    },
    quote: {
      overline: "Demande de devis",
      title: "Recevez votre estimation gratuite",
      sub: "Remplissez le formulaire — nous vous répondons rapidement avec un devis personnalisé.",
      name: "Nom complet",
      email: "Courriel",
      phone: "Téléphone",
      propertyType: "Type de logement",
      city: "Ville",
      surface: "Superficie (pi²) / nb de pièces",
      frequency: "Fréquence",
      services: "Services souhaités",
      message: "Détails supplémentaires",
      submit: "Envoyer ma demande",
      sending: "Envoi...",
      success: "Merci ! Votre demande a bien été envoyée. Nous vous contacterons bientôt.",
      error: "Une erreur est survenue. Veuillez réessayer.",
      propertyOptions: [
        { v: "house", l: "Maison" }, { v: "apartment", l: "Appartement" },
        { v: "condo", l: "Condo" }, { v: "office", l: "Bureau / commercial" },
      ],
      frequencyOptions: [
        { v: "one-time", l: "Une seule fois" }, { v: "weekly", l: "Hebdomadaire" },
        { v: "bi-weekly", l: "Aux deux semaines" }, { v: "monthly", l: "Mensuel" },
      ],
      serviceOptions: ["Nettoyage régulier", "Grand ménage", "Fenêtres", "Emménagement/déménagement", "Bureaux"],
    },
    app: {
      overline: "Application",
      title: "Installez Kelsy sur votre appareil",
      sub: "Accédez à nos services en un clic. Installez l'application directement depuis votre navigateur — aucune boutique requise.",
      install: "Installer l'application",
      installed: "Application installée !",
      unavailable: "Ouvrez le menu de votre navigateur puis « Ajouter à l'écran d'accueil »",
    },
    testimonials: {
      overline: "Témoignages",
      title: "Ce que disent nos clients",
      items: [
        { q: "Maison impeccable à chaque visite. L'équipe est ponctuelle et minutieuse.", a: "Marie L.", c: "Orléans" },
        { q: "Service professionnel et fiable. Je recommande sans hésiter !", a: "David R.", c: "Kanata" },
        { q: "Enfin une entreprise de nettoyage en qui j'ai confiance. Merci Kelsy !", a: "Sophie T.", c: "Gatineau" },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Contactez-nous dès aujourd'hui",
      phone: "343 543 6442",
      email: "Kelsyhousecleaning@gmail.com",
      address: "Ottawa, Ontario",
      social: "Kelsy Housecleaning Ottawa",
    },
    footer: {
      tagline: "Un service professionnel pour une maison impeccable.",
      rights: "Tous droits réservés.",
      quick: "Navigation",
      contactTitle: "Contact",
    },
    admin: {
      loginTitle: "Espace administrateur",
      loginSub: "Connectez-vous pour gérer les devis et factures.",
      email: "Courriel", password: "Mot de passe", login: "Se connecter", loggingIn: "Connexion...",
      dashboard: "Tableau de bord", quotes: "Devis", invoices: "Factures", logout: "Déconnexion",
      welcome: "Bienvenue", welcomeSub: "Gérez vos demandes de devis et vos factures en un seul endroit.",
      statQuotes: "Devis totaux", statNew: "Nouveaux devis", statInvoices: "Factures", statUnpaid: "Impayées", statRevenue: "Revenus encaissés",
    },
  },
  en: {
    brand: "Kelsy Housecleaning",
    location: "Ottawa · Gatineau",
    nav: { services: "Services", why: "Why us", areas: "Areas", quote: "Quote", contact: "Contact", app: "Get the app", admin: "Admin" },
    hero: {
      badge: "Residential & commercial cleaning",
      line1: "A spotless",
      line2: "home,",
      line3: "a lighter mind.",
      sub: "Professional cleaning for homes, apartments, condos and offices across Ottawa & Gatineau. Reliable, thorough, satisfaction guaranteed.",
      cta1: "Request a quote",
      cta2: "Our services",
      stat1: "Happy clients",
      stat2: "Cities served",
      stat3: "Satisfaction guaranteed",
    },
    marquee: ["Clean home", "Light mind", "Quality guaranteed", "Ottawa & Gatineau", "Professional products", "Trusted staff"],
    services: {
      overline: "Our services",
      title: "Cleaning tailored to you",
      sub: "From regular upkeep to deep cleaning, we adapt every visit to your needs.",
      items: [
        { n: "01", t: "Regular cleaning", d: "Weekly, bi-weekly or monthly visits tailored to your lifestyle." },
        { n: "02", t: "Deep cleaning", d: "A top-to-bottom deep clean for a truly spotless result." },
        { n: "03", t: "Homes & apartments", d: "Trusted service for houses, apartments and condos across the Ottawa area." },
        { n: "04", t: "Offices & commercial", d: "Healthy, sparkling workspaces for better productivity." },
        { n: "05", t: "Move in / move out", d: "We restore the space before you arrive or after you leave." },
        { n: "06", t: "On request", d: "Windows, appliances, fridge — tell us exactly what you need." },
      ],
    },
    why: {
      overline: "Why Kelsy",
      title: "Cleanliness is our priority",
      items: [
        { t: "Reliable & trustworthy staff", d: "A trained, courteous and vetted team that respects your privacy." },
        { t: "Pro products & equipment", d: "Effective products and professional-grade equipment." },
        { t: "Satisfaction guaranteed", d: "Not happy? We come back and fix it, free of charge." },
        { t: "Flexible service", d: "Schedules and plans that fit your life." },
      ],
      tagline: "Cleanliness is our priority!",
    },
    areas: {
      overline: "Areas served",
      title: "Proudly serving Ottawa & Gatineau",
      sub: "We cover the entire National Capital Region and surrounding areas.",
      list: ["Ottawa", "Gatineau", "Orléans", "Kanata", "Barrhaven", "Nepean", "Hull", "Aylmer", "Gloucester"],
    },
    quote: {
      overline: "Request a quote",
      title: "Get your free estimate",
      sub: "Fill in the form — we'll get back to you quickly with a personalized quote.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      propertyType: "Property type",
      city: "City",
      surface: "Area (sq ft) / number of rooms",
      frequency: "Frequency",
      services: "Desired services",
      message: "Additional details",
      submit: "Send my request",
      sending: "Sending...",
      success: "Thank you! Your request has been sent. We'll be in touch soon.",
      error: "Something went wrong. Please try again.",
      propertyOptions: [
        { v: "house", l: "House" }, { v: "apartment", l: "Apartment" },
        { v: "condo", l: "Condo" }, { v: "office", l: "Office / commercial" },
      ],
      frequencyOptions: [
        { v: "one-time", l: "One-time" }, { v: "weekly", l: "Weekly" },
        { v: "bi-weekly", l: "Bi-weekly" }, { v: "monthly", l: "Monthly" },
      ],
      serviceOptions: ["Regular cleaning", "Deep cleaning", "Windows", "Move in/out", "Offices"],
    },
    app: {
      overline: "App",
      title: "Install Kelsy on your device",
      sub: "Access our services in one tap. Install the app straight from your browser — no store required.",
      install: "Install the app",
      installed: "App installed!",
      unavailable: "Open your browser menu then \"Add to Home Screen\"",
    },
    testimonials: {
      overline: "Testimonials",
      title: "What our clients say",
      items: [
        { q: "Spotless home every single visit. The team is punctual and thorough.", a: "Marie L.", c: "Orléans" },
        { q: "Professional and reliable service. Highly recommend!", a: "David R.", c: "Kanata" },
        { q: "Finally a cleaning company I trust. Thank you Kelsy!", a: "Sophie T.", c: "Gatineau" },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Get in touch today",
      phone: "343 543 6442",
      email: "Kelsyhousecleaning@gmail.com",
      address: "Ottawa, Ontario",
      social: "Kelsy Housecleaning Ottawa",
    },
    footer: {
      tagline: "A professional service for an impeccable home.",
      rights: "All rights reserved.",
      quick: "Navigation",
      contactTitle: "Contact",
    },
    admin: {
      loginTitle: "Admin space",
      loginSub: "Log in to manage quotes and invoices.",
      email: "Email", password: "Password", login: "Log in", loggingIn: "Logging in...",
      dashboard: "Dashboard", quotes: "Quotes", invoices: "Invoices", logout: "Log out",
      welcome: "Welcome", welcomeSub: "Manage your quote requests and invoices in one place.",
      statQuotes: "Total quotes", statNew: "New quotes", statInvoices: "Invoices", statUnpaid: "Unpaid", statRevenue: "Revenue collected",
    },
  },
};
